
import React from 'react'

const RenderSubmitBtn = ({ isPc, loadingTime, onClickAdd, onClickBuy, disabled }) => {
	return <div className="np-buy-btn">
		{ disabled ?
			<a href="javascript:;" className='btn-np-ect btn-np-disable'><i className="icon-np-shopping"></i>加入购物车</a> :
			<a href="javascript:;" className={isPc ? 'btn-np-ect' : 'btn-np btn-oc-fixed'} onClick={onClickAdd}><i className="icon-np-shopping"></i>加入购物车{loadingTime?<i className="i-oc-loading"></i>:null}</a>
		}
		{ isPc && <a href="javascript:;" className='btn-np btn-oc-fixed' onClick={onClickBuy}>立即购买</a> }
		</div>
}

export {
    RenderSubmitBtn
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/Renders.jsx